var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adress-list-item"},[_c('div',{staticClass:"adress-list-item__title"},[_vm._v(" "+_vm._s(_vm.item.address)+" ")]),_c('div',{staticClass:"adress-list-item__description",domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }